import { useMemo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import QuestionnaireScreen from '../../QuestionnaireScreen';
import { Body } from '../../GridLayout';
import { SubtitleText, TitleText } from '../../../controls/helpers';

const StartQuestions = ({ location }: RouteComponentProps) => {
    const isSummary = useMemo(() => new URLSearchParams(location.search), [location.search]).has('summary');

    return <QuestionnaireScreen hidePrev hideNext>
        <Body isNarrowView>
            <TitleText>Thanks for completing NZ Funds Savings Advice Tool.</TitleText>
            <SubtitleText>Check your email inbox for {isSummary ? `a summary of what we've covered` : 'instructions on how to sign up'}.</SubtitleText>
        </Body>
    </QuestionnaireScreen>
}

export default StartQuestions;
